








































































































































































































import RouteTab from '@/components/RouteTab.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import TitleMixin from '@/mixins/title-mixin';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import AdminChart from '@/components/charts/admin-chart.vue';
import { NodesApi, Node, Site } from '@/api';
import AddUpdateEntityLocation from '@/components/add business objects/addUpdateEntityLocation.vue';
import StatusRow from '@/components/display/information-rows/status-row.vue';
import InlineEditor from '@/components/display/inline-editor.vue';
import SitePicker from '@/components/site-picker.vue';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';
import EntityChargingBehaviourChart from '@/components/charts/entity-charging-behaviour-chart.vue';
import EntityBatteryChart from '@/components/charts/entity-battery-chart.vue';
@Component({
	components: {
		RouteTab,
		EntityBatteryChart,
		EntityChargingBehaviourChart,
		SitePicker,
		InlineEditor,
		StatusRow,
		RouterLinkButton,
		secondaryNav,
		infoTabs,
		AdminChart,
		AddUpdateEntityLocation,
	},
	mixins: [TitleMixin],
})
export default class NodesView extends Vue {
	public smallScreen = window.innerWidth > 1000;
	public loading = false;
	public $bvToast: any;
	public node: any | null = null;
	public site: any | null = null;
	public parentLocations = [];
	public next = '';
	public prev = '';
	public rawData: any[] | null = [];
	public audits: any[] | null = null;
	public fields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	private api: NodesApi = new NodesApi();
	private toast = new Toast();

	private newSite?: Site | null = this.node?.site ?? null;

	public pageTitle() {
		return `node | ${this.node ? this.node.serialNumber : ''}`;
	}

	@Watch('$route.params.nodeId')
	public async load() {
		const { nodeId } = this.$route.params;
		this.loading = true;
		try {
			const { data } = await this.api.getNodeById(parseInt(nodeId, 10), {
				params: {
					include: 'transceiver.gateway,site,audits,sensors,entitylocation',
				},
			});
			this.node = data ?? {};
			this.audits = this.node.audits ?? [];
			this.newSite = this.node.site ?? null;
			this.parentLocations = [];
			if (this.node.site && this.node.site.latitude) {
				this.parentLocations.push({
					type: 'Site',
					latitude: this.node.site.latitude,
					longitude: this.node.site.longitude,
				});
				if (this.node.entitylocation == null) {
					this.node.entitylocation = {
						id: null,
						entityId: this.node.id,
						entityType: 'nodes',
						latitude: null,
						longitude: null,
						notes: null,
					};
				}
			}
		} catch (e) {
			const { errorMessage } = ApiUtils.handleApiError(e, 'Error loading node');
			this.toast.makeToast(errorMessage, 'Error', 'danger');
			this.node = null;
		} finally {
			this.loading = false;
		}
	}

	public async loadDash() {
		//
	}

	public async reload(sortKey: string, prev = false) {
		//
	}

	public async back() {
		this.reload(this.prev, true);
	}

	public async forward() {
		this.reload(this.next, false);
	}

	public created() {
		this.load();
	}

	private updateSite(callback: (hasError: boolean) => void) {
		if (this.newSite === this.node.site) {
			callback(false);
			return;
		}
		try {
			this.api.updateNode(this.node.id!, {
				data: {
					...this.node,
					siteId: this.newSite?.id ?? null,
				},
			});
			this.node.siteId = this.newSite?.id ?? null;
			this.node.site = this.newSite;
			this.toast.makeToast('Updated node site', 'Success Updating Node Site', 'success');
			callback(false);
		} catch (ex) {
			const { errorMessage } = ApiUtils.handleApiError(ex, 'Error updating node site');
			this.toast.makeToast(errorMessage, 'Error Updating Node Site', 'danger');
			callback(true);
		}
	}
}
